/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import PropTypes from 'prop-types';
import Select from 'react-select';
import SalesChart from './SalesChart';
import { sortByOptionsForPOS } from '../../helper'
import { setCurrencyFormat } from '../../../../utils/helpers';

const SalesShow = ({ dir, data, viewReportButton, title, optionShow, companyBasedOn }) => {
    const thisMonthData = {};
    const currentDataByCompany = {};

    const [sortBySelected, setSortBySelected] = useState(sortByOptionsForPOS[1])

    data.forEach((item) => {
        if (item && currentDataByCompany[item?.[companyBasedOn]]) {
            currentDataByCompany[item?.[companyBasedOn]]?.push(item)
        } else if (item) {
          if (!item?.[companyBasedOn] || item?.[companyBasedOn] === 'null') {
            currentDataByCompany?.['N/A']?.push(item)
          } else {
            currentDataByCompany[item?.[companyBasedOn]] = [item]
          }
        }
      });
  const currentCompanyData = Object.keys(currentDataByCompany);
  const options = [];
  let dataToPlot = [];

  const reduceCallbackForYear = (acc, day) => {
    if (acc[day?.year]) {
      acc?.[day?.year]?.push(day)
    } else {
      acc[day?.year] = [day]
    }    
    return acc
  }

  const reduceCallbackForWeekly = (acc, day) => {
    const MonthWeek = `${day.monthStr}- wk ${day?.week}-${day?.year}`;
    if (acc[MonthWeek]) {
      acc?.[MonthWeek]?.push(day)
    } else {
      acc[MonthWeek] = [day]
    }    
    return acc
  }

  const reduceCallbackForMonthly = (acc, day) => {
    const monthData = `${day.monthStr}-${day?.year}`;
    if (acc[monthData]) {
      acc?.[monthData]?.push(day)
    } else {
      acc[monthData] = [day]
    }    
    return acc
  }

  const reduceCallbackForYearly = (acc, day) => {
    const yearData = `${day?.year}`;
    if (acc[yearData]) {
      acc?.[yearData]?.push(day)
    } else {
      acc[yearData] = [day]
    }    
    return acc
  }

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF'.split('');
    let fillColor = '#';
    for (let i = 0; i < 6; i += 1) {
        fillColor += letters[Math.floor(Math.random() * 16)];
    }
    return fillColor;
}

  for (let i = 0; i < currentCompanyData.length; i += 1) {
    const cat = currentCompanyData[i];
    const currentMonth = currentDataByCompany?.[cat] ?? [];
    let currentYearMonthMax = 0;
    currentMonth?.forEach((item) => {
      currentYearMonthMax += Number(item.amount)
    }
    );
    const finalDatayearwise = []; 
    
    const yearWiseData = currentMonth?.reduce(reduceCallbackForYear, {})

    const currentYearData = Object.keys(yearWiseData);
    const finalDataForPlot = [];

    for (let j = 0; j < currentYearData.length; j += 1) {
      const currYear = currentYearData[j];
      const currentYear = yearWiseData?.[currYear] ?? [];

      let currentYearMonthDayWise = {}
         if (optionShow?.value === 'weekly'){
          // console.log(sortByMonth(currentYear))
          currentYearMonthDayWise = currentYear?.sort((a, b) => a.month > b.month ? 1 : -1)?.
          sort((a, b) => a.week > b.week ? 1 : -1)?.reduce(reduceCallbackForWeekly, {})
         }
         else if (optionShow?.value === 'monthly'){
          currentYearMonthDayWise = currentYear?.sort((a, b) => a.month > b.month ? 1 : -1)?.
          reduce(reduceCallbackForMonthly, {})
         }
         else {
          currentYearMonthDayWise = currentYear?.sort((a, b) => a.year > b.year ? 1 : -1)?.
          reduce(reduceCallbackForYearly, {})
         }
    
    const innerData = []
    const categoryWiseAmountTotal = Object.keys(currentYearMonthDayWise).reduce((acc, monthyear) => {
      let amount = currentYearMonthDayWise[monthyear]?.reduce((accum, item) => Number(Number(Number(accum) +
        Number(item.amount)).toFixed(2)), 0);
      amount = Math.abs(amount); 
      const curYear = monthyear.split('-')  
      let dayValue = ''
      let dataMonth = ''
      if (optionShow?.value === 'weekly'){
       dayValue = `${curYear[0]}-${curYear[1]}`
       dataMonth = `${curYear[0]}`
       }
       else if (optionShow?.value === 'monthly'){
        dayValue = `${curYear[0]}`
        dataMonth = `${curYear[0]}`
       }
       else {
        dayValue = monthyear
        dataMonth = monthyear
       } 
      innerData.push({ day: dayValue,
        month: dataMonth,
        Amount: amount})
        acc[monthyear] = {
          day: monthyear,
        Amount: amount        
      };
      return acc
    }, {})

    finalDataForPlot.push({
      name: currYear,
      data: innerData,
      color: getRandomColor()
  })
}
    
    options.push({
      value: cat, label: cat
    })
    
    dataToPlot.push({
      title: cat,
      finalDataForPlot,
      currentYearMonthMax: currentYearMonthMax > 0 ? currentYearMonthMax : 0
    })

  }
  
  const sortBy = sortBySelected?.value;
    if (sortBy === 'title') {
      console.log(sortBy)
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy]?.toLowerCase() > b?.[sortBy]?.toLowerCase() ? 1 : -1)
    } else {
        dataToPlot = dataToPlot?.sort((a, b) =>
            a?.[sortBy] < b?.[sortBy] ? 1 : -1)
    }

    return (
        <Col xs="12">
            <Card className="pb-3 show-categ-daily-sales">
                <div className="card__title row " style={{ position: 'relative' }} >
                <h5 className="bold-text col-md-7">{title}</h5>
                <div className="form__form-group mb-0 col-md-4" id='dvChartFilter'>
                    <div className="row justify-content-center align-items-center"> 
                    <div className="col-3 text-right">
                      <span className="form__form-group-label font-weight-bold">Sort By</span>
                      </div>                       
                        <div className="col-4">
                            
                            <div className="form__form-group-field">
                                <Select
                                    value={sortBySelected}
                                    options={sortByOptionsForPOS}
                                    clearable={false}
                                    placeholder="Sort By"
                                    className="select_filter-110"
                                    onChange={setSortBySelected}
                                    classNamePrefix="react-select"
                                />
                            </div>

                        </div>
                    </div>
                </div>
                <div className="col-1" id='dvChartView'>
                    {viewReportButton?.()}
                    </div>
                </div>

                {dataToPlot?.length ? dataToPlot?.map((category, index) => (                   
                <Row key={category.title}>
                    <Col sm={4} md={2}><CardText>{category.title} <br />
                       {setCurrencyFormat(Number(category.currentYearMonthMax).toFixed(2), true)}
                        </CardText></Col>
                    <Col sm={8} md={10}>
                        <SalesChart dir={dir}
                            totalDays={365}
                            dataToShow={category?.finalDataForPlot}
                            height={275}
                            showTitle={false}
                            category={category.title}
                            companyBasedOn={companyBasedOn}
                            index={index}
                        /> 
                        </Col>
                </Row>
            )) : 'No data to display'}
            </Card>
        </Col>

    )
}

SalesShow.propTypes = {
    dir: PropTypes.string.isRequired,
    data: PropTypes.arrayOf({}).isRequired,
    title: PropTypes.string,
    viewReportButton: PropTypes.func.isRequired,
    optionShow: PropTypes.object.isRequired,
    companyBasedOn: PropTypes.string
};

SalesShow.defaultProps = {
    title: 'Sales',
    companyBasedOn: 'companyName',
}

export default SalesShow;
